import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Grid } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useHistory, useLocation } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import useBulkCreatePrivateDrivers from '../../../../../hooks/driver/useBulkCreatePrivateDrivers';
import ButtonComponent from '../../../../atoms/button';
import Input from '../../../../atoms/input';
import ModalCustom from '../../../../atoms/modalCustom';
import Typography from '../../../../atoms/typography';
import schema from './schema';
import useUpdatePrivateDriverData from '../../../../../hooks/driver/useUpdatePrivateDriverData';
import { removeSpecialChars } from '../../../../../services/mask';
import useUpdateDriver from '../../../../../hooks/driver/useUpdateDriver';

interface IDriverForm {
  id: string;
  username: string;
  cpf: string;
  phoneNumber: string;
}

const actualTabNumber = '4';

const FormUpdatePrivateDrivers: React.FC = () => {
  const location = useLocation<{ driver?: IDriverForm }>();
  const history = useHistory();
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const { execute: executeUpdateDriver, loading } = useUpdateDriver();
  const {
    control,
    formState: { isValid, isDirty, defaultValues },
    getValues,
    reset,
  } = useForm<IDriverForm>({
    resolver: yupResolver(schema),
    mode: 'onChange',
    defaultValues: {
      id: location.state.driver?.id || uuidv4(),
      username: location.state.driver?.username || '',
      cpf: location.state.driver?.cpf || '',
      phoneNumber: location.state.driver?.phoneNumber || '',
    },
  });

  const updateDriver = async () => {
    const formValues = getValues();
    await executeUpdateDriver({
      data: {
        cpf: removeSpecialChars(formValues.cpf),
        phoneNumber: removeSpecialChars(formValues.phoneNumber),
        username: formValues.username,
      },
      driverId: formValues.id,
      callback: () => {
        history.goBack();
      },
    });
  };

  const cancelOperation = () => {
    history.goBack();
  };

  const decideToCancelOperation = () => {
    if (!isDirty) cancelOperation();
    else setOpenCancelModal(true);
  };

  const canEdit = () => {
    const formDefaultValues = JSON.stringify(defaultValues);

    return formDefaultValues !== JSON.stringify(getValues()) && isValid;
  };

  return (
    <Box style={{ display: 'flex', gap: 20, flexDirection: 'column' }}>
      <Typography fontWeight="700" color="secondary">
        Editar motorista
      </Typography>

      <Box>
        <Grid container spacing={2} key={location.state.driver?.id}>
          <Grid item xs={4}>
            <Input
              size="small"
              label="CPF"
              placeholder="000.000.000-00"
              mask="999.999.999-99"
              control={control}
              name={`cpf`}
            />
          </Grid>
          <Grid item xs={4}>
            <Input
              name={`username`}
              control={control}
              size="small"
              label="Nome"
              placeholder="João exemplo"
            />
          </Grid>
          <Grid item xs={4}>
            <Input
              name={`phoneNumber`}
              control={control}
              size="small"
              label="Celular"
              placeholder="(00)00000-0000"
              mask="(99)99999-9999"
            />
          </Grid>
        </Grid>
        <br />
      </Box>

      <Grid container justifyContent="space-between">
        <ButtonComponent
          theme="outline-primary"
          justifyContent="flex-start"
          flex={1}
          onClick={decideToCancelOperation}
        >
          Cancelar
        </ButtonComponent>
        <ButtonComponent
          onClick={updateDriver}
          theme="primary"
          justifyContent="flex-end"
          flex={1}
          disabled={!canEdit()}
        >
          Editar motorista
        </ButtonComponent>
      </Grid>

      <ModalCustom
        open={openCancelModal}
        onCancelClick={() => setOpenCancelModal(false)}
        onClickPublish={cancelOperation}
        ButtonOutlinePrimary="Cancelar"
        ButtonPrimary="Confirmar"
        alignCenter={true}
        hideCloseIcon={true}
        label="Deseja descartar as modificações que estavam sendo cadastradas nesse formulário?"
        boxStyle={{
          display: 'flex',
          flexDirection: 'column',
          textAlign: 'center',
          gap: 2,
        }}
      />
    </Box>
  );
};

export default FormUpdatePrivateDrivers;
